import React, {Component} from 'react'

// import {LineChart, Line, CartesianGrid, XAxis, YAxis} from 'recharts';
import {XYPlot, XAxis, YAxis, HorizontalGridLines, LineSeries, AreaSeries} from 'react-vis';


import Avatar from 'react-avatar'
import M from 'materialize-css'
import {Link} from "react-router-dom";


class Profile extends Component {

    constructor(props) {
        super(props)
    }

    getRandomDataHtml() {
        const suggestions = ["Eye Contact", "Fillers", "Voice Volume", "Posture", "Clothing"];
        return suggestions.map(item => {
                const percentage = Math.random() * 100;
                let color = "";
                let comment = "";

                if (percentage < 30) {
                    color = "red"
                    comment = "This is an area for improvement."
                } else if (percentage < 60) {
                    color = "orange"
                    comment = "You did alright, we can work on it."
                } else {
                    color = "green"
                    comment = "Great job, you are good at this."
                }

                return (
                    <div>
                        {item}
                        <div className={"progress lighten-4 " + color}>
                            <div className={"determinate " + color} style={{width: percentage + "%"}}></div>
                        </div>
                    </div>
                )
            }
        )
    }

    componentDidMount() {
        this.reInit()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.reInit()
    }

    reInit() {
        M.AutoInit();
    }

    render() {

        const data = [{name: 'Page A', uv: 400, pv: 2400, amt: 2400}, {
            name: 'Page B',
            uv: 500,
            pv: 2400,
            amt: 2400
        }];

        /*const renderLineChart = (
            <LineChart width={window.innerWidth / 2} height={300} data={data} margin={{top: 5, right: 20, bottom: 5, left: 0}}>
                <Line type="monotone" dataKey="uv" stroke="#8884d8"/>
                <CartesianGrid stroke="#ccc" strokeDasharray="5 5"/>
                <XAxis dataKey="name"/>
                <YAxis/>
            </LineChart>
        );*/


        let improvementData = []
        for (let i = 1; i <= 5; i++) {
            const random = Math.random();
            improvementData.push(random * 100)
        }

        improvementData = improvementData.sort((a, b) => a - b)
        console.log(improvementData)
        improvementData = improvementData.map((item, index) => {
            return {
                x: index,
                y: item
            }
        });


        const rendereLineChart = (
            <div className={"center card-panel"}>
                <XYPlot
                    width={300}
                    height={180}
                    style={{width: "100% !important;", height: "auto", padding: "3%"}}
                >
                    <HorizontalGridLines/>
                    <AreaSeries
                        color={"blue"}
                        data={improvementData}/>
                    <XAxis hideTicks/>
                    <YAxis hideTicks/>
                </XYPlot>
                <p>You are tracking well!</p>
            </div>
        );


        const recentActivity = [
            {date: "1 day ago", humanFeedback: ""},
            {
                date: "2 days ago",
                humanFeedback: "You seem to be doing well, keep going. Practice the common questions and you shall be set."
            }
        ];


        return (
            <div className={"row"}>


                <div className={"col s12 center grey lighten-3"} style={{paddingTop: "3%"}}>
                    <Avatar name={"Ishan Joshi"} round={true}/>
                    <p>Ishan Joshi</p>
                    <br/>

                    <button className={"btn blue"}
                            style={{borderRadius: "3.5em"}}>
                        <Link className={"white-text"} to="/">Practice Interview</Link>
                    </button>

                    <br/>
                    <br/>
                </div>


                <div className={"col s12"}>
                    <div className="row">
                        <div className="col s12">
                            <ul className="tabs">
                                <li className="tab col s4"><a className="active" href="#test1">Activity</a></li>
                                <li className="tab col s4"><a href="#test2">Profile</a></li>
                                <li className="tab col s4 disabled"><a href="#test3">Premium</a></li>
                            </ul>
                        </div>
                        <div id="test1" className="col s12" style={{marginTop: "5%", overFlowY: "auto"}}>

                            {/*<ul className="collection with-header">*/}
                            {/*<li className="collection-item" style={{borderBottom: "unset"}}>*/}

                            {/*// </li>*/}

                            <div>

                                {

                                    recentActivity.map(item => {
                                        return (

                                            <div className={"card-panel z-depth-1"}>
                                                <p className={"grey-text"}>{item.date}</p>
                                                {
                                                    this.getRandomDataHtml()
                                                }
                                                {
                                                    item.humanFeedback === "" ? (
                                                        <button className={"btn blue"}
                                                                style={{borderRadius: "3.5em"}}>
                                                            Human Feedback
                                                        </button>
                                                    ) : (
                                                        <div>
                                                            <h5>Human Feedback</h5>
                                                            <p>{item.humanFeedback}</p></div>

                                                    )

                                                }
                                            </div>


                                        )
                                    })

                                }
                            </div>

                            {/*</ul>*/}


                        </div>
                        <div id="test2" className="col s12">

                            {rendereLineChart}

                        </div>
                        <div id="test3" className="col s12">Test 3</div>
                    </div>
                </div>


            </div>
        )


    }

}

export default Profile

